var React = require('react');

function Down (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Path_574","data-name":"Path 574","d":"M731.4,1763.846l23.25-31.172c2.213-2.764,1.127-5.025-2.415-5.025H739.444a6.389,6.389,0,0,0,.194-1.5v-23.407a6.456,6.456,0,0,0-6.438-6.439H721.549a6.457,6.457,0,0,0-6.438,6.439v23.407a6.392,6.392,0,0,0,.194,1.5h-12.79c-3.542,0-4.628,2.261-2.415,5.025l23.25,31.172A4.942,4.942,0,0,0,731.4,1763.846Z","transform":"translate(-698.953 -1696.306)","fill":"#606060"}));
}

Down.defaultProps = {"width":"50px","height":"50px","viewBox":"0 0 56.842 69.612"};

module.exports = Down;

Down.default = Down;
